import { Box } from "@mui/material";
import { Link } from "@reach/router";
import React from "react";
import notificationUtil from "../../utils/notificationUtil";
import TaskTypeEnum from "../taskmanager/taskTypeEnum";

const cardSx = {
  mb: 2,
  p: 2,
  border: "1px solid #ddd",
  borderRadius: "12px",
  boxShadow: 1,
  backgroundColor: "#fff",
  ":hover": {
    backgroundColor: "#f7f8fa",
  },
};

const headline = (props, isPickupChangeRequest) => {
  if (isPickupChangeRequest) {
    return props["Status"] === "Cancelled"
      ? "Customer cancelled pickup change request."
      : props["TaskName"] || "Customer requested pickup change.";
  }
  if (props["Type"] === "CREATE") return `${props["UserName"]} assigned a task to you.`;
  if (props["Type"] === "UPDATE") return `${props["UserName"]} updated a task.`;
  if (props["Type"] === "DELETE") return `${props["UserName"]} deleted a task.`;
  if (props["Type"] === "CALL") return `${props["UserName"]} missed a patient call.`;
  return props["TaskName"] || "Task update";
};

export const TaskNotificationComponent = ({ props }) => {
  const isPickupChangeRequest = props["TaskTypeID"] === TaskTypeEnum.PickupChangeRequest;
  const title = isPickupChangeRequest
    ? headline(props, true)
    : props["TaskName"] || "Task update";
  const detail = isPickupChangeRequest ? null : headline(props, false);
  const statusColor = notificationUtil.statusColor(props["Status"]) || "#6B778C";

  return (
    <Box component="section">
      <Link
        to="/home/taskmanager"
        style={{
          textDecoration: "none",
          color: "inherit",
        }}
      >
        <Box sx={cardSx}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={1}
            gap={1}
          >
            <Box sx={{ fontWeight: "bold", fontSize: "14px", color: "#172b4d" }}>
              {title}
            </Box>
            <Box sx={{ fontSize: "12px", color: "gray", whiteSpace: "nowrap" }}>
              {notificationUtil.timeSince(new Date(props["CreatedOn"]))}
            </Box>
          </Box>
          {detail ? (
            <Box sx={{ fontSize: "13px" }}>{detail}</Box>
          ) : null}
          <Box
            sx={{
              fontSize: "13px",
              color: statusColor,
              fontStyle: "italic",
              mt: 1,
            }}
          >
            Status: {props["Status"]}
          </Box>
          <Box sx={{ fontSize: "13px", mt: 1 }}>
            {props["TaskTypeName"]}
            {props["Priority"] ? ` · ${props["Priority"]}` : ""}
          </Box>
        </Box>
      </Link>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/TaskNotificationComponent.js